module.exports = __webpack_public_path__ + "static/media/5.60cf5cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/5.png
// module id = 738
// module chunks = 0